<template>
    <div>
        <el-popover ref="popover-org-tree" placement="top-start" trigger="click">
            <div class="popover-tree">
                <div class="hint block row" style="height: 48px;z-index: 10000;margin-top: 0px;">
                    <div v-if="multiSelect">
                        <a class="swb-btn swb-btn-small" @click="checkSelect">确认选择</a>
                    </div>
                    <div v-else>
                        <i class="icon iconfont icon-tongzhi1 mr10 font-gold"></i>
                        <span>温馨提示：鼠标双击选中</span>
                    </div>
                </div>
                <div style="overflow-y: auto; height: 600px;">
                    <div class="tab-container small base">
                        <div class="tabs-nav">
                            <ul class="head">
                                <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                                    <span>{{ status.text }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="checkStateValue == 0">
                        <swb-org-tree :bizDepart="bizDepart || departFlag" :optionalState="optionalState" :defalultState="defalultState" :isSelectThisLevel="isSelectThisLevel" :dblclickFlag="true" :isCom="isCom" :accordion="accordion" :enableSearch="true"
                                      :isShowIcon="false" :closedComSelect="closedComSelect" @notity-change="notityChange($event)" @notity-init-change="notityInitChange($event)"></swb-org-tree>
                    </div>
                    <div v-else-if="checkStateValue == 1">
                        <swb-mgmt-area-tree :onlyOrg="mgmtOnlyOrg" :isSelectThisLevel="isSelectThisLevel" :dblclickFlag="true" :isCom="isCom" :accordion="accordion" :enableSearch="true" :isShowIcon="false" :closedComSelect="closedComSelect"
                                            @notity-change="notityChange($event)" @notity-init-change="notityInitChange($event)"></swb-mgmt-area-tree>
                    </div>
                    <div v-else>
                        <swb-real-com-tree ref="realComTree" :realComDefFirst="realComDefFirst" :multiSelect="multiSelect" :enableSearch="true" :accordion="accordion" :dblclickFlag="true" :costFlag="costFlag" :prftFlag="prftFlag"
                                           :selectRealComId="selectRealComId" @notity-change="notityChange($event)" @notity-init-change="notityInitChange($event)"></swb-real-com-tree>
                    </div>
                </div>
            </div>
            <!--<el-button type="primary" slot="reference">-->
            <!--<span>组织结构</span>-->
            <!--<i class="icon iconfont icon-down-sanjiao"></i>-->
            <!--</el-button>-->
            <div class="org-tree-btn" slot="reference">
                <span>选择机构</span>
                <i class="icon iconfont icon-down-sanjiao"></i>
            </div>
        </el-popover>
        <div class="org-tree-factor">
            <div class="factor-item">
                <span>【选中机构】</span>
                <span v-if="itemInfo.id != null" :title="displayName">{{ displayName }}</span>
                <span v-else>无</span>
            </div>
            <div v-show="itemInfo.level <= 4 && (checkStateValue == 0 || checkStateValue == 1)" class="factor-item">
                <el-checkbox v-if="showIncludeSubComs == true" v-model="includeSubComs" @change="handleCheckedChange">全部下级机构</el-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, filterByName, Routes} from '../../app.vues'

    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    import shopDevcApi from '../../api/shopDevc'
    import merchtComnApi from '../../api/merchtComn'

    import SwbMgmtAreaTree from '../orgStruct/MgmtAreaTree';

    Vue.regist(SwbMgmtAreaTree);

    import SwbRealComTree from '../orgStruct/RealComTree';

    Vue.regist(SwbRealComTree);

    export default {
        name: 'swb-popover-org-tree',
        desc: '组织架构树组件',
        props: {
            showIncludeSubComs: { // 显示跨组织勾选
                type: Boolean,
                default: false
            },
            initIncludeSubComs: { // 设置初始值
                type: Boolean,
                default: false
            },
            isCom: {    // 是否获取全部的公司
                type: Boolean,
                default: false
            },
            accordion: {    // 是否手风琴模式
                type: Boolean,
                default: false
            },
            isSelectThisLevel: { //本级是否可选
                type: Boolean,
                default: false
            },
            optionalState: { // 可选的state
                type: Array,
                default: function () {
                    return [1, 3, 4];
                }
            },
            defalultState: { // 默认选中的state
                type: Array,
                default: function () {
                    return [1, 3]
                }
            },
            selectComId: {
                type: Number,
                default: null
            },
            closedComSelect: {
                type: Boolean,
                default: false
            },
            showMgmt: {
                type: Boolean,
                default: false
            },
            mgmtRelaySeq: {
                type: Boolean,
                default: true
            },
            departFlag: {
                type: Boolean,
                default: false
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            // 临时用来兼容默认显示部门用
            tmpBizDepart: {
                type: Boolean,
                default: true
            },
            mgmtOnlyOrg: {
                type: Boolean,
                default: true
            },
            showRealCom: { // 展示实体公司组织机构
                type: Boolean,
                default: false
            },
            onlyShowRealCom: { // 仅展示实体公司组织机构
                type: Boolean,
                default: false
            },
            costFlag: { // 是否获取成本中心
                type: Boolean,
                default: false
            },
            prftFlag: { // 是否获取利润中心
                type: Boolean,
                default: true
            },
            selectRealComId: {  // 当前实体公司Id
                type: Number,
                default: null
            },
            multiSelect: { // 公司树支撑
                type: Boolean,
                default: false
            },
            realComDefFirst: { // 公司树是否默认第一个
                type: Boolean,
                default: true
            }
        },
        watch: {},
        data: function () {
            return {
                includeSubComs: false,
                itemInfo: {},
                displayName: '',
                tableState: [{
                    "text": "人事组织机构",
                    "value": 0,
                }],
                checkStateValue: 0,
                defComId: null
            }
        },
        created: function () {
            let tableState = this.tableState || [];
            if (Utils.isTrue(this.showMgmt)) {
                tableState = [];
                if (Utils.isTrue(this.mgmtRelaySeq)) {
                    tableState.push({"text": "人事组织机构", "value": 0,});
                    tableState.push({"text": "区域组织机构", "value": 1,});
                    this.checkStateValue = 0;
                } else {
                    tableState.push({"text": "区域组织机构", "value": 1,});
                    tableState.push({"text": "人事组织机构", "value": 0,});
                    this.checkStateValue = 1;
                }
            }
            if (Utils.isTrue(this.onlyShowRealCom)) {
                tableState = [];
                tableState.push({"text": "公司组织机构", "value": 2,});
                this.checkStateValue = 2;
            } else {
                if (Utils.isTrue(this.showRealCom)) {
                    tableState.push({"text": "公司组织机构", "value": 2,});
                }
            }
            this.tableState = Utils.merge([], tableState);
            //
            this.includeSubComs = this.initIncludeSubComs || false;
            if (this.selectComId != null) {
                this.defComId = this.selectComId + '';
            }
            if (this.selectComId != null || (this.bizDepart && this.tmpBizDepart)) {
                this.getComInfo(this.defComId);
            }
        },
        methods: {
            checkSelect: function () {
                let selectDatas = this.$refs.realComTree.getCheckedNodes();
                let self = this;
                //
                this.itemInfo = {id: -1};
                this.displayOrgName(selectDatas);
                //
                this.$emit('notity-change', selectDatas);
                self.$refs["popover-org-tree"].doClose();
            },
            notityChange: function (data) {
                let self = this;
                if (data.level <= 4) {
                    data.includeSubComs = this.includeSubComs;
                }
                this.itemInfo = data;
                //
                this.displayOrgName();
                //
                this.$emit('notity-change', data);
                self.$refs["popover-org-tree"].doClose();
            },
            notityInitChange: function (data) {
                if (this.defComId == null) {
                    if (data.comFlag == null) {
                        if (data.level <= 4) {
                            data.includeSubComs = this.includeSubComs;
                        }
                        this.itemInfo = Utils.merge({}, data);
                        //
                        this.displayOrgName();
                        //
                        this.$emit('notity-init-change', data);
                    } else {
                        this.itemInfo = Utils.merge({}, data);
                        //
                        this.displayOrgName();
                        //
                        this.$emit('notity-init-change', data);
                    }
                    //
                    if (Utils.isTrue(data.realFlag) && Utils.isTrue(this.onlyShowRealCom)) {
                        this.$emit('notity-change', data);
                    }
                }
            },
            handleCheckedChange: function () {
                let data = this.itemInfo;
                if (data.level <= 4) {
                    data.includeSubComs = this.includeSubComs;
                }
                this.itemInfo = Utils.merge({}, data);
                //
                this.displayOrgName();
                //
                this.$emit('notity-change', data);
            },
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                //let theLoad = MsgBox.loading();
                retailerApi.getRetailerCom(postData, function (result) {
                    if (result != null && result.type == 'info') {
                        let data = result.data;
                        //
                        if (data.level <= 4) {
                            data.includeSubComs = self.includeSubComs;
                        }
                        self.itemInfo = Utils.merge({}, data);
                        self.defComId = data.id;
                        self.displayOrgName();
                        //
                        self.$emit('notity-init-change', data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            displayOrgName: function (selectDatas) {
                let self = this;
                if (selectDatas != null && selectDatas.length) {
                    let displayName = null;
                    for (let i = 0; i < selectDatas.length; i++) {
                        let name = selectDatas[i].name;
                        if (displayName == null) {
                            displayName = name;
                        } else {
                            displayName = displayName + '、' + name;
                        }
                    }
                    self.displayName = displayName == null ? "" : displayName;
                } else {
                    let itemInfo = this.itemInfo;
                    //
                    if (itemInfo.mgmtFlag) {
                        self.displayName = itemInfo.name;
                    } else {
                        if (itemInfo.orgType == 1 || itemInfo.mgmtId != null || Utils.isTrue(itemInfo.realFlag)) {
                            self.displayName = itemInfo.name;
                        } else if (Utils.isTrue(itemInfo.centerFlag)) {
                            self.displayName = itemInfo.code + '-' + itemInfo.name;
                        } else if (!Utils.isNoB(itemInfo.bizUnitName)) {
                            self.displayName = itemInfo.bizUnitName + ' - ' + itemInfo.name;
                        } else {
                            self.displayName = itemInfo.name;
                        }
                    }
                }
            },
            handleTabClick(val) {
                this.checkStateValue = val;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/PopoverOrgTree.vue